import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const ContactNotes = ({ ...props }) => {
  return (
    <React.Fragment>
      <div id='notes-scroll-content' className='notes-scroll-block'>
        {(props.notes || []).map((value, index) => <Note note={value.note} timestampEntered={value.timestampEntered} key={index} />)}
      </div>

    </React.Fragment>
  );
};

export const Note = (props) => (
  <div className='note-wrapper'>
    <div className='pt-2 pb-2 note-content-wrapper'>
      <div className='note'>
        {props.note}
        <div className='d-flex justify-content-between'>
          <small className='text-muted'>
            {moment(props.timestampEntered).format('MM/DD/YYYY hh:mm A')}
          </small>
        </div>
      </div>
    </div>
  </div>);

Note.propTypes = {
  note: PropTypes.string,
  timestampEntered: PropTypes.string
};

ContactNotes.propTypes = {
  notes: PropTypes.array
};

export default ContactNotes;
